<template>
    <div class="bfb100">
        <van-Row class="bmwcCon">
            <van-Col span="24">
              <div class="shxxCon">
                <div class="bmsuccess"><img :src=bmcgimg width="50%" /></div>
                <p>报名成功</p>
                <div style="margin:50px 16px 16px;"><van-button round block type="info" class="bottom-button" @click="ckbmxx">查看报名信息</van-button></div>
              </div>
            </van-Col>

        </van-Row>
    </div>
</template>

<script>
export default {
    data(){
        return{
            bmcgimg:require('@/assets/images/bmcgimg.png')
        }
    },
    created() {
    this.jzht();
    },
    methods:{
        jzht(){
          history.pushState(null, null, document.URL); //禁止网页返回上一页
          window.addEventListener('popstate', function() {
            history.pushState(null, null, document.URL);
          });
        },
        //查看报名信息
        ckbmxx(){
            this.$router.push('/personal/login?meetingId='+this.$cookies.get('meetingId'));
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bfb100{
    height: 100vh;
    background: url(~@/assets/images/bmcgbg.png) no-repeat bottom center;
    background-size: contain;
  }
  .bmsuccess{
    text-align: center;
    padding:40px 0 0;
  }
  .shxxCon p{
    padding:0 40px 50px;
    line-height: 26px;
    text-align: center;
    font-size: 20px;
    color:#628998;
  }
</style>



// WEBPACK FOOTER //
// src/components/Free/index.vue